import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { LogoHorizontal } from "@/components/brand/LogoHorizontal";

/** Centered, chrome-free onboarding shell — DESIGN.md §8.2 (03 Onboarding). */
export function OnboardingLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg px-4 py-12">
      <Link to="/" aria-label="Studside home" className="mb-8">
        <LogoHorizontal size="lg" />
      </Link>
      <div className="flex w-full max-w-6xl justify-center">{children}</div>
    </div>
  );
}
